// @flow
import React, { Component } from 'react';
import MenuBarBase from "./MenuBarBase";

const my_league_urls = ['/leagues', '/leagues/join', '/leagues/create'];
const my_league_items = [
	{
		name: "My Leagues",
		to: `/leagues`,
		exact: true
	},
	{
		name: "Join a League",
		to: `/leagues/join`,
		message: 'Leagues cannot be joined after Round 25 has begun'
	},
	{
		name: "Create a League",
		to: `/leagues/create`,
		message: 'Leagues cannot be created after Round 25 has begun'
	}
];

const league_urls = [
	{ path: '/league/:league_id', exact: true },
	'/league/:league_id/fixtures',
	'/league/:league_id/ladder',
	'/league/:league_id/transactions',
	'/league/:league_id/team-breakdowns',
];
const league_items = (league_id: number): Array<Object> => [
	{
		name: "League Overview",
		to: `/league/${league_id}`,
		exact: true
	},
	{
		name: "Fixtures",
		to: `/league/${league_id}/fixtures`,
	},
	{
		name: "Ladder",
		to: `/league/${league_id}/ladder`,
	},
	{
		name: "Transactions",
		to: `/league/${league_id}/transactions`,
	}
];

const league_team_urls = [
	'/league/:league_id/team',
	'/league/:league_id/team/pre-draft',
	'/league/:league_id/team/live-draft'
];
const league_team_items = (league_id: number): Array<Object> => [
	{
		name: "My Team",
		to: `/league/${league_id}/team`,
	}
];

const league_settings_urls = [
	'/league/:league_id/settings',
	'/league/:league_id/about',
	'/league/:league_id/draft-order'

];
const league_settings_items = (league_id: number): Array<Object> => [
	{
		name: "League Settings",
		to: `/league/${league_id}/settings`,
	},
	{
		name: "Team & Draft Order",
		to: `/league/${league_id}/draft-order`,
	},

];

const league_matchup_urls = [
	'/league/:league_id/matchup',

];
const league_matchup_items = (league_id: number): Array<Object> => [
	{
		name: "Match Ups",
		to: `/league/${league_id}/matchup`,
	},

];

const league_players_urls = [ '/league/:league_id/players' ];
const league_players_items = (league_id: number): Array<Object> => [
	{
		name: "Players",
		to: `/league/${league_id}/players`,
	}
];

type TUrlPath = any;

const isPathsMatchPath = (
	path_patterns: Array<TUrlPath>,
	pathname: string
): boolean => {
	// split pathname and remove any empty strings
	const pathname_split_trimmed = pathname.split('/').reduce((acc, item) => {
		if(item) acc.push(item);
		return acc;
	}, []);

	// iterate through path_patterns and check if any match the pathname
	return path_patterns.some(path_pattern => {
		const is_object = typeof path_pattern === 'object';
		const path_pattern_string = is_object ? path_pattern.path : path_pattern;
		const exact = is_object ? path_pattern.exact : false;

		const path_pattern_split_trimmed =
			path_pattern_string.split('/').reduce((acc, item) => {
				if(item) acc.push(item);
				return acc;
			}, []);

		// if pathname items has all url path items then is match
		const is_match = path_pattern_split_trimmed.every((item, index) => {
			const pathname_item = pathname_split_trimmed[index];

			// if url path item starts with : then this signifies a dynamic path
			// value so we'll just check that a pathname_item exists
			if (item.startsWith(':') && pathname_item) {
				return true;
			}

			return item === pathname_item;
		});

		// if exact then paths must match in length
		const is_paths_matching_required_length = exact ?
			pathname_split_trimmed.length === path_pattern_split_trimmed.length :
			true;

		return is_match && is_paths_matching_required_length;
	});
};

type Props = {
	location: {
		pathname: string
	},
	league?: {
		id: number
	},
	leagues: Array<Object>,
	openHamburgerMenu: Function,
	user_id: number,
	is_last_round_started: boolean
}

class MenuBar extends Component<Props> {

	// eslint-disable-next-line complexity
	get nav_items() {
		const { location: { pathname }, league } = this.props;

		if (isPathsMatchPath(my_league_urls, pathname)) {
			return my_league_items;
		}

		if (league) {
			if (isPathsMatchPath(league_urls, pathname)) {
				return league_items(league.id);
			}

			if (isPathsMatchPath(league_team_urls, pathname)) {
				return league_team_items(league.id);
			}

			if (isPathsMatchPath(league_settings_urls, pathname)) {
				return league_settings_items(league.id);
			}

			if (isPathsMatchPath(league_matchup_urls, pathname)) {
				return league_matchup_items(league.id);
			}

			if (isPathsMatchPath(league_players_urls, pathname)) {
				return league_players_items(league.id);
			}
		}

		return [];
	}

	render() {
		const { openHamburgerMenu, leagues, league, user_id, is_last_round_started } = this.props;

		return (
			<MenuBarBase
				is_last_round_started={is_last_round_started}
				nav_items={this.nav_items}
				openHamburgerMenu={openHamburgerMenu}
				selected_league={league}
				leagues={leagues}
				user_id={user_id}
			/>
		);
	}
}

export default MenuBar;


// WEBPACK FOOTER //
// ./src/components/MenuBar/index.js